let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i1SaR")).then(() => parcelRequire('9lsQo'));